import {
    Dashboard as DashboardIcon,
    Notifications as NotificationsIcon,
    Settings as SettingsIcon,
} from "@mui/icons-material";
import {
    Box,
    Button,
    keyframes,
    Paper,
    Slider,
    styled,
    TextField,
    Typography,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {setSuccess} from "../../Redux/AlertReducer";
import {Helper} from "../../tools/Helper";
import {api_Routes} from "../../tools/api_Routes";
import ReusableSmmTicketProfileCard from "./SmmTicketProfileCard.tsx";
import ArticleIcon from "@mui/icons-material/Article";
import {SmmticketCampaingsTable} from "./SmmticketCampaingsTable";

// Animation keyframes
const slideIn = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

// Styled components
const SmmTicketProfileCard = styled(Paper)(({theme}) => ({
    animation: `${slideIn} 0.3s ease-out`,
    transition: "all 0.2s ease",
    "&:hover": {
        transform: "translateY(-2px)",
    },
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));
const SmmTicketProfile = ({data, campaings,getData,currentPage,setCurrentPage,rowsPerPage,setRowsPerPage}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [settings, setSettings] = useState({
        min_count: 0,
        cost_per_one: 0,
        countries: [],
        maxCount: 0,
        balance: 0
    });
    useEffect(() => {
        if (data) {
            setSettings({
                min_count: Number(data?.min_count) || 0,
                cost_per_one: Number(data?.cost_per_one) || 0,
                maxCount: Number(data?.maxCount) || 0,
                balance: Number(data?.balance) || 0,
                countries: data?.countries || [],
            });
        }
    }, [data]);
    const settingsConfig = [
        {
            key: "min_count",
            label: "Min count of the ticket",
            value: settings.min_count || 0,
            type: "number",
            unit: "Ticket",
            inputProps: {min: 1, max: 100},
        },
        {
            key: "maxCount",
            label: "Max count of the ticket",
            value: settings.maxCount || 0,
            type: "number",
            unit: "Ticket",
            inputProps: {min: 1, max: 100},
        },
        {
            key: "cost_per_one",
            label: "The Cost of one ticket",
            value: settings.cost_per_one || 0,
            type: "number",
            unit: "$",
            inputProps: {min: 1, max: 100},
        },
        {
            key: "balance",
            label: "Your balance in the smmticket",
            value: settings.balance || 0,
            type: "number",
            unit: "$",
            inputProps: {min: 1, max: 100},
        },
    ];
    return (
        <>
            <Box sx={{p: 3, maxWidth: 800, margin: "0 auto"}}>
                <Box sx={{textAlign: "center", mb: 4}}>
                    <SettingsIcon sx={{fontSize: 40, mb: 1}}/>
                    <Typography variant="h4" gutterBottom>
                        Smmticket Profile
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Show the data of the smmticket
                    </Typography>
                </Box>
                <ReusableSmmTicketProfileCard
                    title="Account Info"
                    settings={settingsConfig}
                    icon={<DashboardIcon/>}
                />


            </Box>
            <SmmticketCampaingsTable
                campaings={campaings}
                getData={getData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </>

    );
};
export default SmmTicketProfile;
